module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA0UlEQVR4AbSTjQ2CMBCFWyfpKLCJTEKcRJxEmUSc5PxeEy41LQnEYPzo9d31tcfPJfz5cwMzG83sbjtZ93UDhBRjHOIOqPV/aeDikaBpQBvXBqllXBmwsFnYWiytMuAeLEqUoE1Q6aqpDE45gXba4pwT0K96drZ2l16dQOIRfgy4gR28IT9Kxvx6y5A4wRM6zVdKAyVGEj3kb4LxAzOLpIuBucxVSxhCaaCee/rX81bhTCxtolJGD+bKvZhLYygMSN6ywoV4AS9SDFoYGJXz2i8AAAD//yJu0FwAAAAGSURBVAMAsEKHIeClYogAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/invoice_w.png
// module id = xd5/
// module chunks = 3